'use client'; // src/use-event-listeners.ts

import { useCallback, useEffect, useRef } from "react";

function useEventListeners() {
  var listeners = useRef( /* @__PURE__ */new Map());
  var currentListeners = listeners.current;
  var add = useCallback(function (el, type, listener, options) {
    listeners.current.set(listener, {
      type: type,
      el: el,
      options: options
    });
    el.addEventListener(type, listener, options);
  }, []);
  var remove = useCallback(function (el, type, listener, options) {
    el.removeEventListener(type, listener, options);
    listeners.current.delete(listener);
  }, []);
  useEffect(function () {
    return function () {
      currentListeners.forEach(function (value, key) {
        remove(value.el, value.type, key, value.options);
      });
    };
  }, [remove, currentListeners]);
  return {
    add: add,
    remove: remove
  };
}

export { useEventListeners };